import { createSlice } from "@reduxjs/toolkit";
import { layer } from "../../config";

const initialState = layer;

const overlayLayerSlice = createSlice({
  name: "overlaylayer",
  initialState,
  reducers: {
    setAnalyticsDetails: (state, action) => {
      const id = action.payload.id;

      if (id !== undefined) {
        // Update each field only if it exists in action.payload, preserving the current state otherwise
        state[id].show = action.payload.show ?? state[id].show;
        state[id].layer = action.payload.layer ?? state[id].layer;
        state[id].layer_date = action.payload.layer_date ?? state[id].layer_date;
        state[id].opacity = action.payload.opacity ?? state[id].opacity;
        state[id].date = action.payload.date ?? state[id].date;
        state[id].altitude = action.payload.altitude ?? state[id].altitude;
        state[id].dataset = action.payload.dataset ?? state[id].dataset;
        state[id].datatype = action.payload.datatype ?? state[id].datatype;
        state[id].modelname = action.payload.modelname ?? state[id].modelname;
        state[id].modeltype = action.payload.modeltype ?? state[id].modeltype;
        state[id].noofdays = action.payload.noofdays ?? state[id].noofdays;
        state[id].legend = action.payload.legend ?? state[id].legend;
        state[id].nextdate = action.payload.nextdate ?? state[id].nextdate;
        state[id].isPlaying = action.payload.isPlaying ?? state[id].isPlaying;
        state[id].odate = action.payload.odate ?? state[id].odate;
        state[id].hours = action.payload.hours ?? state[id].hours;
        state[id].showGeopotentialHeights = action.payload.showGeopotentialHeights ?? state[id].showGeopotentialHeights;
        state[id].showWindVectors = action.payload.showWindVectors ?? state[id].showWindVectors;
        state[id].variables = action.payload.variables ?? state[id].variables;

      }
    },
  },
});

export const { setAnalyticsDetails } = overlayLayerSlice.actions;
export const selectLayerDataSet = (state) => state.overlaylayer;
export default overlayLayerSlice.reducer;
